import { FC, memo } from 'react';

import { ImageData } from '../VariationOne';
import { getWatermarkTag } from '../shared';
import SharedUploadedImageRow from '../shared/UploadedImageRow';
import WatermarkSettingsModal from './WatermarkSettingsModal';

interface Props {
  image: ImageData;
  imageIndex: number;
  setImages: React.Dispatch<React.SetStateAction<ImageData[]>>;
}

const UploadedImageRow: FC<Props> = ({ image, imageIndex, setImages }) => {
  const settingsApplied = getWatermarkTag(image) !== 'none';

  return (
    <SharedUploadedImageRow
      image={image}
      imageIndex={imageIndex}
      setImages={setImages as any}
      showSettings
      settingsApplied={settingsApplied}
      settingsModal={
        <WatermarkSettingsModal
          image={image}
          imageIndex={imageIndex}
          setImages={setImages as any}
          onClose={() => {}}
        />
      }
      showText={false}
      showPreview={false}
      aspectRatio={929 / 1232}
      imgRatioX={61}
      imgRatioY={80}
    />
  );
};

export default memo(UploadedImageRow);
